<template>
    <!-- 用户授权书 -->
    <div class="my-agree">
        <template v-if="dataResult">
            <div class="right-box">
                <p class="title" v-if="valuetxt">《{{ valuetxt }}》</p>
                <div v-html="dataResult"></div>
            </div>
            <div class="auth" v-if="fromPage === 'person'">
                <div class="txt-auth">
                    <span>授权人：</span><span class="txt-line">{{ userInfo && userInfo.realName }}</span>
                </div>
                <div class="txt-auth">
                    <span>日期：</span><span class="txt-line">{{timetxt}}</span>
                </div>
            </div>
            <div class="right-box" v-else-if="dataResult && this.times > 3">
                <div class="mt20 agree_btn" @click="handleChange">
                    已阅读
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import withRouteTracking from '@/utils/withRouteTracking'
import { dataDictionary, queryAgreeByUserId } from '@/api/api'
const UserProfile = {
  name: 'agree',
  data () {
    return {
      checked: false,
      dataResult: '',
      valuetxt: '',
      timetxt: '',
      show: false,
      times: 0
    }
  },
  computed: {
    userInfo () {
      return this.$store.getters.userInfo
    },
    fromPage () {
      return this.$route.query.fromPage
    },
    type () {
      return this.$route.query.type
    }
  },
  mounted () {
    if (this.fromPage === 'person') {
      queryAgreeByUserId({
        userId: this.userInfo.id,
        type: this.type
      }).then(res => {
        if (res.data) {
          this.show = true
          this.timetxt = this.$moment(parseInt(res.data.createTime)).format('YYYY-MM-DD')
        }
      })
    }
    this.handleLoad()
  },
  methods: {
    handlesetTime () {
      this.timeouts = setTimeout(() => {
        this.times++
        if (this.times > 3) {
          clearTimeout(this.timeouts)
        } else {
          this.handlesetTime()
        }
      }, 1000)
    },
    handleLoad () {
      let types = this.$route.query.typeArgee
      const params = {
        typeCode: 'PRIVACYAGREEMENT',
        dataStatus: 1,
      }
      dataDictionary(params).then((res) => {
        if (res.code === 0) {
          let dataResult = res.data.filter(itm => itm.code === types)
          this.dataResult = dataResult && dataResult.length > 0 ? dataResult[0].explainContent : ''
          this.valuetxt = dataResult && dataResult.length > 0 ? dataResult[0].value : ''
          if (this.fromPage && this.fromPage === 'person') return
          this.handlesetTime()
        }
      })
    },
    handleChange () {
      this.$router.go(-1)
    },
  },
}
// 这块是路由跟踪埋点的功能，具体实现在utils/withRouteTracking.js
export default withRouteTracking(UserProfile)
</script>

<style lang="less" scoped>
.my-agree {
    background: #FFF;
    width: 100%;

    .auth {
        text-align: right;
        padding: 20px;
        box-sizing: border-box;

        .txt-auth {
            display: block;
            line-height: 32px;

            .txt-line {
                padding-bottom: 2px;
                border-bottom: 1px solid #000;
            }
        }
    }

    .right-box {
        padding: 24px 14px 18px 16px;

        .hidden {
            display: none;
        }

        .title {
            font-family: PingFang HK, PingFang HK;
            font-weight: 600;
            font-size: 24px;
            color: #1a1a1a;
            text-align: center;
            margin-bottom: 10px;
        }

        .agree_btn {
            margin: 20px auto;
            width: 240px;
            height: 42px;
            background: #EB1700;
            border-radius: 100px;
            font-family: Helvetica, Helvetica;
            font-weight: 400;
            font-size: 16px;
            color: #fff;
            line-height: 42px;
            text-align: center;
        }

        .van-radio--horizontal {
            margin-right: none !important;
        }

        .noActive {
            background: #f2f3f7;
            color: #6a7481;
            pointer-events: none !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/person/agreeDetailPage.vue